
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46.4","height":"46","viewBox":"0 0 46.4 46"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#D0342C","cx":"23.2","cy":"23","r":"22.4"}}),_c('path',{attrs:{"stroke":"#EFEFEA","stroke-width":"4","stroke-linecap":"round","d":"M13.8 13.6l18.8 18.8M32.6 13.6L13.8 32.4"}})])
          )
        }
      }
    